import React, { useRef } from "react";

const NewFluidIntake = ({ onSubmit, onCancel }) => {
	// ref
	const offeredRef = useRef(null);
	const amountTakenRef = useRef(null);
	const datetimeRef = useRef(new Date());
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					amountTaken: amountTakenRef.current.value,
					datetime: datetimeRef.current.value,
					offered: offeredRef.current.value
				});
			}}
		>
			<div className="form-group">
				<label htmlFor="fluid-id">Fluid Offered*</label>
				<input
					type="text"
					className="form-control input-height"
					id="fluid-id"
					required
					ref={offeredRef}
					aria-describedby="fluid-id"
					placeholder="enter fluid offered"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="amount-taken">Amount Taken*</label>
				<input
					type="text"
					className="form-control input-height"
					id="amount-taken"
					required
					ref={amountTakenRef}
					aria-describedby="amount-taken"
					placeholder="enter amount taken"
				/>
			</div>

			<div className="form-group">
				<label htmlFor="date-taken">Date & Time*</label>
				<input
					type="datetime-local"
					className="form-control input-height"
					id="date-taken"
					required
					ref={datetimeRef}
					aria-describedby="date-taken"
				/>
			</div>

			<div className="form-group text-center">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>
			</div>
		</form>
	);
};

export default NewFluidIntake;
